import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { DropDown, RadioContainer } from "../../../commons";
import Select from "react-select";
import { ModeType, SelectParentType } from ".";
import { RadioTypes } from "../../../../commonTypes/universalTypes";

type AppProps = {
  isEdit: boolean;
  menuDetailsError: {};
  menuDetails: {};
  handleMenuDetailsChange: () => void;
  finalParentList: [];
  parentSelected: SelectParentType;
  handleParentData: (mode: any) => void;
  SELECT_CATEGORY_OPTION: ModeType[];
  handleChangeSelectedMode: (mode: any) => void;
  categorySelected: ModeType;
  RADIO_OPTIONS: RadioTypes[];
  handleSetRadioValue: (radioValue: string) => void;
  isClientUrl: string;
  COMING_SOON_OPTIONS: RadioTypes[];
  handleSetCommingSoonValue: (mode: any) => void;
  isCommingSoon: string;
  IS_NEW_OPTIONS: RadioTypes[];
  handleSetIsNewValue: (mode: any) => void;
  isNew: string;
  handleResetEditData: () => void;
  handleResetData: () => void;
  handleSubmitForm: () => void;
  Option: any;
};

const AddEditModalData = ({
  isEdit,
  menuDetailsError,
  menuDetails,
  handleMenuDetailsChange,
  finalParentList,
  parentSelected,
  handleParentData,
  SELECT_CATEGORY_OPTION,
  handleChangeSelectedMode,
  categorySelected,
  RADIO_OPTIONS,
  handleSetRadioValue,
  isClientUrl,
  COMING_SOON_OPTIONS,
  handleSetCommingSoonValue,
  isCommingSoon,
  IS_NEW_OPTIONS,
  handleSetIsNewValue,
  isNew,
  handleResetEditData,
  handleResetData,
  handleSubmitForm,
  Option,
}: any) => {
  const { finacKeyError, selectCategoryError, menuNameError } =
    menuDetailsError;
  const {
    menuName,
    actionName,
    finacKey,
    menuCategory,
    apiUrl,
    frontendRoute,
    activeIcon,
    icon,
    description,
    paramsType
  } = menuDetails;
  return (
    <>
      <Modal isOpen={true} backdrop="static" size="lg">
        <ModalHeader className="pt-4 pl-4">
          {`${isEdit ? "Edit" : "Add"} Menu`}
        </ModalHeader>
        <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
          {/* Third Row */}
          <div className="row">
            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label
                      htmlFor="menuName"
                      className={menuName ? "active" : ""}
                    >
                      Enter Menu Name*
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        !!menuNameError ? "error-border" : null
                      }`}
                      name="menuName"
                      value={menuName}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                  <div>
                    {!!menuNameError && (
                      <small className="text-danger">{menuNameError}</small>
                    )}
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label
                      htmlFor="actionName"
                      className={actionName ? "active" : ""}
                    >
                      Enter Action
                    </label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="actionName"
                      value={actionName}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label htmlFor="GROUP">Select Parent</label>
                    <Select<any, false>
                      classNamePrefix="react-select"
                      inputProps={{ autoComplete: "nope" }}
                      options={finalParentList}
                      className={`react-select`}
                      value={parentSelected}
                      onChange={handleParentData}
                      isSearchable
                      components={{ Option }}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <form>
                <span className="form-group">
                  <label
                    htmlFor="menuCategory"
                    className={menuCategory ? "active" : ""}
                  >
                    Select Category*
                  </label>
                </span>
                <div>
                  <DropDown
                    options={SELECT_CATEGORY_OPTION}
                    handleChange={handleChangeSelectedMode}
                    value={categorySelected}
                  />
                </div>
                <div>
                  {!!selectCategoryError && (
                    <small className="text-danger">{selectCategoryError}</small>
                  )}
                </div>
              </form>
            </div>
            <div className="col-md-4">
              <form>
                <div>
                  <span>
                    <label htmlFor="isClientUrl">Client / User Url</label>
                  </span>

                  <div className="mt-2 mb-4">
                    <RadioContainer
                      optionsList={RADIO_OPTIONS}
                      handleSetRadioValue={handleSetRadioValue}
                      radioValue={isClientUrl}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="col-md-4">
              <form>
                <span className="form-group">
                  <label htmlFor="accountNumber">Coming soon ?</label>
                </span>

                <div className="mt-2 mb-4">
                  <RadioContainer
                    optionsList={COMING_SOON_OPTIONS}
                    handleSetRadioValue={handleSetCommingSoonValue}
                    radioValue={isCommingSoon}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label
                      htmlFor="actionName"
                      className={finacKey ? "active" : ""}
                    >
                      Enter Finac Key*
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        !!finacKeyError ? "error-border" : null
                      }`}
                      name="finacKey"
                      value={finacKey}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                  {!!finacKeyError && (
                    <small className="text-danger">{finacKeyError}</small>
                  )}
                </div>
              </form>
            </div>
            <div className="col-md-4">
              <form className="mt-3">
                <span className="form-group">
                  <label htmlFor="accountNumber">Is New ?</label>
                </span>
              </form>
              <div className="mt-2 mb-4">
                <RadioContainer
                  optionsList={IS_NEW_OPTIONS}
                  handleSetRadioValue={handleSetIsNewValue}
                  radioValue={isNew}
                />
              </div>
            </div>

            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label
                      htmlFor="actionName"
                      className={icon ? "active" : ""}
                    >
                      Icon
                    </label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="icon"
                      value={icon}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label htmlFor="apiUrl" className={apiUrl ? "active" : ""}>
                      Api Url
                    </label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="apiUrl"
                      value={apiUrl}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label
                      htmlFor="actionName"
                      className={frontendRoute ? "active" : ""}
                    >
                      Frontend Route
                    </label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="frontendRoute"
                      value={frontendRoute}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="col-md-4">
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label
                      htmlFor="actionName"
                      className={activeIcon ? "active" : ""}
                    >
                      Active Icon
                    </label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="activeIcon"
                      value={activeIcon}
                      onChange={(e) => handleMenuDetailsChange(e)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <label
                htmlFor="Description"
                className={description ? "active" : ""}
              >
                Description
              </label>
              <textarea
                className={`form-control`}
                name="description"
                value={description}
                onChange={(e) => handleMenuDetailsChange(e)}
                maxLength={150}
              />
            </div>

            <div className="col-md-4">
              <div>
                <label htmlFor="actionName" className={paramsType ? "active" : ""}>
                  Param Type
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="paramsType"
                  value={paramsType}
                  onChange={(e) => handleMenuDetailsChange(e)}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <span
            className="pointer"
            onClick={() => {
              handleResetEditData();
              handleResetData();
            }}
          >
            Cancel
          </span>
          <Button color="primary ml-3" onClick={handleSubmitForm}>
            {isEdit ? "Update Menu" : "Create Menu"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default AddEditModalData;
